<template>
  <div class="animated fadeIn">
    <Forms ref="frmDefault"
      :title="'CADASTRO DE CONFIGURAÇÃO DE HORARIO'"
      :showClearButton="true"
      :showSaveButton="true"
      :showBackButton="true"
      :disabledKeyUpEnter="true"
      :isModal="isModal"
      v-on:Clear="onClear"
      v-on:Back="$emit('Back')"
      v-on:Save="onSave">
      <div class="form-group row">
        <div class="col-md-2">
          <label for="txtData"><small v-if="form.dataInicial.required"  class="text-danger">*</small>Data de criação</label>
          <div class="input-group">
            <b-form-input disabled type="date"
              id="txtData"
              name="txtData"
              v-model="currentDate"
              required/>
          </div>
        </div>
        <div class="col-md-4">
          <label><small v-if="form.diaSemana.required" class="text-danger">*</small> Dia da semana:</label>
          <div class="input-group">
            <b-form-input v-model="form.diaSemana.value"
                          :options="daysOfWeek"
                          :required="form.diaSemana.required"
                          :state="form.diaSemana.state"
            ></b-form-input>
          </div>
        </div>
        <div class="col-md-3">
          <label ><small v-if="form.horaInicial.required" class="text-danger">*</small> Hora Inicial:</label>
          <div class="input-group">
            <b-form-input type="time"
                          v-model="form.horaInicial.value"
                          :size="form.horaInicial.maxlength"
                          :required="form.horaInicial.required"
                          :state="form.horaInicial.state"
            ></b-form-input>
          </div>
        </div>
        <div class="col-md-3">
          <label ><small v-if="form.horaFinal.required" class="text-danger">*</small> Hora Final:</label>
          <div class="input-group">
            <b-form-input type="time"
                          v-model="form.horaFinal.value"
                          :size="form.horaFinal.maxlength"
                          :required="form.horaFinal.required"
                          :state="form.horaFinal.state"
            ></b-form-input>
          </div>
        </div>
      </div>
    </Forms>
  </div>
</template>
<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import { toast, loading } from '@/shared/utils/UIHelper'
import Tools from '@/components/tools/Tools.js'

import HorarioAtendimentoRepository from '@/shared/http/repositories/configurations/horarioatendimento.js'
import HorarioAtendimentoModel from '@/shared/models/configurations/horarioAtendimentomodel.js'
import HorarioAtendimentoForms from './horarioAtendimentoadd-form.js'

export default {
  name: 'WhatsAppConfigurationsAdd',
  mixins: [ActionsForm],
  props: {
    isModal: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      data: HorarioAtendimentoModel,
      form: HorarioAtendimentoForms,
      currentDate: this.getCurrentDate()
    }
  },
  methods: {
    onLoad () {
    },
    onClear () {
      this.form.horaInicial.value = '08:30'
      this.form.horaFinal.value = '18:00'
    },
    onEdit (obj) {
      if (obj) {
        loading.push()
        this.data.dataInicial = this.currentDate
        Tools.SetValueInForm(this.form, this.data, obj)
        if (obj.diaSemana) {
          this.form.diaSemana.value = obj.diaSemana
        }

        loading.pop()
      }
    },
    onCreate () {
      loading.push()
      this.data.dataInicial = this.currentDate
      if (this.data.dataInicial) {
        this.data.dataInicial = this.data.dataInicial + 'T' + this.moment().format('HH:MM:SS.mmmmm')
      }
      HorarioAtendimentoRepository.Create(this.data)
        .then((response) => {
          console.log(response)
          loading.close()
          this.$emit('Back')
          toast.success(this.$lang.Common.Alerts.Success)
        })
        .catch(this.onException)
    },
    onUpdate () {
      loading.push()
      this.data.id = parseInt(this.data.id)
      this.data.dataInicial = this.currentDate
      if (this.data.dataInicial) {
        this.data.dataInicial = this.data.dataInicial + 'T' + this.moment().format('HH:MM:SS.mmmmm')
      }
      this.data.diaSemana = this.form.diaSemana.value
      HorarioAtendimentoRepository.Update(this.data)
        .then((response) => {
          loading.close()
          this.$emit('Back')
          toast.success(this.$lang.Common.Alerts.Success)
        })
        .catch(this.onException)
    },
    getCurrentDate () {
      const date = new Date()
      const day = date.getDate().toString().padStart(2, '0')
      const month = (date.getMonth() + 1).toString().padStart(2, '0')
      const year = date.getFullYear()
      return `${year}-${month}-${day}`
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/parametros_atendimento/horarioAtendimento/components/add/horarioAtendimentoadd.vue